export default [
    {
        id: 1,
        // label: {
        //     en: 'Waiting for reply',
        //     et: 'Ootab vastust',
        //     ru: 'Ожидает ответа'
        // },
        label: {
            en: 'Waiting for support reply',
            et: 'Ootab klienditoe vastust',
            ru: 'Ожидает ответа поддержки',
            lv: "Gaida atbalsta atbildi",
            lt: "Laukiama pagalbos atsakymo",
            fi: "Odottaa tuen vastausta",
        },
        // color: 'green',
        color: 'yellow',
    },
    {
        id: 3,
        // label: {
        //     en: 'Answered',
        //     et: 'Vastatud',
        //     ru: 'Отвечено'
        // },
        label: {
            en: 'Support replied',
            et: 'Klienditugi vastas',
            ru: 'Поддержка ответила',
            lv: "Atbalsts atbildējis",
            lt: "Pagalba atsakė",
            fi: "Tuki vastasi",
        },
        // color: 'blue',
        color: 'green'
    },
    {
        id: 5,
        label: {
            en: 'Closed',
            et: 'Suletud',
            ru: 'Закрыт',
            lv: "Slēgts",
            lt: "Uždaryta",
            fi: "Suljettu",
        },
        color: 'dark-blue'
    },
    {
        id: 7,
        label: {
            en: 'Deleted by user',
            et: 'Kasutaja kustutas',
            ru: 'Удалён пользователем',
            lv: "Lietotājs dzēsis",
            lt: "Ištrinta naudotojo",
            fi: "Käyttäjä poistanut",
        },
        color: 'red'
    },
]